// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Img-none-e840{opacity:0}.Img-fit-e840{max-width:100%;max-height:100%}.Img-cover-e840{width:100%;height:100%;object-fit:cover}`, "",{"version":3,"sources":["webpack://./src/component/Image/Img.module.scss"],"names":[],"mappings":"AAAA,eACE,SAAA,CAGF,cACE,cAAA,CACA,eAAA,CAGF,gBACE,UAAA,CACA,WAAA,CACA,gBAAA","sourcesContent":[".none {\n  opacity: 0;\n}\n\n.fit {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.cover {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"none": `Img-none-e840`,
	"fit": `Img-fit-e840`,
	"cover": `Img-cover-e840`
};
module.exports = ___CSS_LOADER_EXPORT___;
